/**
 * Convert %string% into string let..
 * Usage: parse('hello %string%, how are you doing', my_name);
 *
 * @param str - String to modfiy
 * @returns Modified string
 */
export function parse(str) {
    let args = [].slice.call(arguments, 1),
        i = 0;

    return str.replace(/%[a-zA-Z]+%/g, function () {
        return args[i++];
    });
}

/**
 * Convert currency code to currency symbol, or the othe way around.
 * Usage: ccySwap('EUR', 'symbol');
 *
 * @param str - Currency code
 * @param convertTo - 'Symbol' or 'Code' or null
 * @returns Symbol or code
 */
export function ccySwap(str, convertTo) {
    try {
        if (convertTo === 'symbol' || !convertTo) {
            return (0).toLocaleString("en", {style: "currency", currency: str}).replace("0.00", "").replace("0", "");
        }
    } catch (e) {
        return '';
    }
}

/**
 * Convert object keys and values to query string.
 *
 * @param obj - Input object
 * @param keys - Keys to search for
 * @param aliases - Keys to use
 * @return Result string
 */
export function keyize(obj, keys, aliases) {
    let result = '';
    keys.forEach((key, index) => {if (obj[key]) { result += `&${aliases[index]}=${encodeURIComponent(obj[key])}` } });
    return result;
}

/**
 * Get function for below parser
 */
const get = (path, obj, fb = `$\{${path}}`) => {
    return path.split('.').reduce((res, key) => res[key] || fb, obj);
};

/**
 * Template parser for string. Simple example:
 * parseTemplate('${name} is now master of the ${galaxy}', {
 *     name: 'John',
 *     galaxy: 'Milky Way',
 * });
 *
 * Source: https://gist.github.com/smeijer/6580740a0ff468960a5257108af1384e
 */
export const parseTemplate = (template, map, fallback) => {
    return template.replace(/\$\{.+?}/g, (match) => {
        const path = match.substr(2, match.length - 3).trim();
        return get(path, map, fallback);
    });
};

/**
 * Convert string params, or get params from url and return them in object
 * Supports commutativity of hash and parameters.
 *
 * @param str - URL string
 * @returns Object containing params or hash
 */
export const paramsToObject = (str) => {

    // When search is empty, hash is leading in URL
    if (window.location.search === "") {

        // #hash&param1=a&param2=b -> split by question mark and take the right part
        let params = (str === undefined) ? (window.location.hash.split("&")) : str;
        params.shift();
        params = params.join().replace(/(,)/g, "&");

        // Format the output
        return (params !== '')
            ? JSON.parse('{"' + decodeURI(params).replace(/"/g, '\\"').replace(/(&)$/g, "").replace(/((=)((?!&).)*(=))/ig, "=").replace(/&/g, '","').replace(/=/g, '":"') + '"}')
            : false;
    } else {

        // ?param1=a&param2=b#hash -> hash will be natively ignored
        let params = (str === undefined) ? window.location.search.substring(1) : str;

        // Format the output
        return (params !== '')
            ? JSON.parse('{"' + decodeURI(params).replace(/"/g, '\\"').replace(/(&)$/g, "").replace(/((=)((?!&).)*(=))/ig, "=").replace(/&/g, '","').replace(/=/g, '":"') + '"}')
            : false;
    }
}

/**
 * Get hash value from URL
 * Supports commutativity of hash and parameters
 *
 * @param validate - String which has to match hash key
 * @returns Hash
 */
export const getHash = (validate) => {
    let hash = false;
    let part = (window.location.search === "") ? window.location.hash.split("&")[0].substring(1).split("=") : window.location.hash.substring(1).split("=");

    if (typeof validate !== "undefined") {
        hash = (part[0] === validate) ? part[1] : false;
    } else {
        hash = part[1];
    }

    return hash || false;
}

/**
 * Remove keys holding specific value from object.
 *
 * @param obj - Object to search in
 * @param value - Keys using this value will be removed
 * @returns Modified object
 */
export const filterKeys = (obj, value) => {
    for (let key in obj) {
        if (obj[key] === value) {
            delete obj[key];
        }
    }

    return obj;
}

/**
 * Apply decodeURIComponent on certain keys of certain object.
 *
 * @param on - Object
 * @param keys - Array of string keys that should be in object
 * @returns New object with decoded values
 */
export const forceDecode = function (on, keys) {
    for (let i = 0; i < keys.length; i++) {
        if (typeof on[keys[i]] === 'undefined') break;
        on[keys[i]] = decodeURIComponent(on[keys[i]]);
    }
}

/**
 * Calculates IBAN from BBAN
 *
 * @param accountCountryCode - Account country code
 * @param accountPrefix - Account prefix
 * @param accountNumber - Account number
 * @param accountBankCode - Bank code
 * @returns Created iban
 */
export const generateIban = function (accountCountryCode, accountPrefix, accountNumber, accountBankCode) {
    // We can't use this method on void data.
    if (!accountPrefix || !accountNumber || !accountBankCode) {
        return '';
    }

    // convert letters to char codes
    const _getCharCodes = (chars) => {
        const A = 'A'.charCodeAt(0);
        const Z = 'Z'.charCodeAt(0);
        return chars.split('').map(function (char) {
            const code = char.charCodeAt(0);
            if (code >= A && code <= Z) {
                return code - A + 10;
            } else {
                return char;
            }
        }).join('');
    };

    // calculate modulo from long string
    const _mod97 = (digitString) => {
        let m = 0;
        for (let i = 0; i < digitString.length; ++i) {
            m = ((m * 10) + (digitString[i] |0)) % 97;
        }
        return m;
    };


    // prepare calculation string
    const calculationStr = `${accountBankCode}${accountPrefix}${accountNumber}${_getCharCodes(accountCountryCode)}00`;

    // calculate control number
    const controlNr = (98 - _mod97(calculationStr)).toString().padStart(2, '0');

    // return IBAN
    return `${accountCountryCode}${controlNr}${accountBankCode}${accountPrefix}${accountNumber}`;
};

/**
 * Get IBAN from accounts() request result.
 *
 * @param value - Request result string
 * @returns IBAN
 */
export const getAccountIbanFromRequestResult = (value) => {
    return value.match(/\: SK[0-9][0-9](.*)/g)[0].replace(': ', '').replace(/\s/g, '');
}

/**
 * Get account name from accounts() request result.
 *
 * @param value - Request result string
 * @returns Account name
 */
export const getAccountNameFromRequestResult = (value) => {
    return value.match(/(.{0,100}): SK[0-9][0-9]/g)[0].replace(/: SK[0-9][0-9]/, '');
}

/**
 * Splits IBAN into chunks by 4 chars.
 *
 * @param val - Original iban
 * @returns Prettyfied iban
 */
export const ibanReadability = function (val) {
    if (typeof val === 'undefined') { return false };

    try {
        var readableIban = val.replace(/[^\dA-Za-z]/g, '').replace(/(.{4})/g, '$1 ').trim();
        return readableIban;
    } catch(ParsingException) {
        return val;
    }
}

const isIpadOS13 = () => /\bMacintosh\b/.test(navigator.userAgent) && navigator.maxTouchPoints > 1;

const isIOsDevice = () => /iPhone|iPad|iPod/i.test(navigator.userAgent) || isIpadOS13();

const isAndroidDevice = () => /android/i.test(navigator.userAgent);

/**
 * Detect mobile or tablet.
 *
 * @returns Flag if device is mobile or tablet or not
 */
export const isMobile = () => isIOsDevice() || isAndroidDevice();

/**
 * Cast string into b-separated numeric form.
 *
 * @param value - String input value
 * @param delimiters - Encoded parts separator
 * @returns Binary number form string
 */
export const b_num_form = (value, delimiters) => {
    return value.split('').map((val) => {
        return val.charCodeAt(0)
    }).join(delimiters.inner);
}

/**
 * Obfuscation intermediate representation.
 *
 * @param arr - Array of input values
 * @param delimiters - Encoded parts separator
 * @returns Intermediate representation string
 */
export const obfuscationIR = (arr, delimiters) => {
    return arr.map((val) => {
        return b_num_form(val, delimiters);
    }).join(delimiters.outer);
}

/**
 * Main obfuscation function.
 *
 * @param arr - Array of input values
 * @param delimiters - Encoded parts separator
 * @returns Final obfuscation string
 */
export const obfuscate = (arr, delimiters) => {
    return URIFriendlyBtoa(URIFriendlyBtoa(obfuscationIR(arr, delimiters)));
}

/**
 * Unobfuscate string.
 *
 * @param val - String input value
 * @param falseAlias - Which value means false
 * @param delimiters - Encoded parts separator
 * @returns Unobfuscated string
 */
export const unobfuscate = (val, falseAlias, delimiters) => {
    let found = [];
    URIFriendlyAtob(URIFriendlyAtob(val)).split(delimiters.outer).forEach((_val, _idx) => {
        _val.split(delimiters.inner).forEach((__val, __idx) => {
            if (found[_idx] === undefined) {found[_idx] = '';}
            found[_idx] += String.fromCharCode(__val);
        });
    });
    return found.map((val) => {return val !== falseAlias});
}

/**
 * Atob with special handling of = signs.
 *
 * @param str - Input string
 * @returns Btoa with replaced equal signs
 */
export const URIFriendlyBtoa = (str) => {
    return btoa(str).replace(/=/g, '_e');
};

/**
 * Atob with special handling of = signs.
 *
 * @param str - Input string
 * @returns Atob with reversed equal signs
 */
export const URIFriendlyAtob = (str) => {
    return atob(str.replace(/_e/g, '='));
};

/**
 * Parametrze object keys and values.
 *
 * @param obj - Object of key-value pairs
 * @returns Query param string
 */
export const parametrize = function (obj) {
    let val = '';

    for (let i = 0; i < Object.keys(obj).length; i++) {
        val += Object.keys(obj)[i] + '=' + obj[Object.keys(obj)[i]] + '&';
    }

    return val.slice(0, -1);
}

export const splitStringForScreanReader = (value) => {
    if (!value) return;

    return value.split('').join(' ');
};

export const formatNumber = (value) => {
    const formattedValue = value.toLocaleString('sk-SK', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const fixedFormattedValue = formattedValue.replace('-', '−');

    return fixedFormattedValue;
}
